<template>
    <div id="main" v-show="rotaAninhada">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page" v-else>
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ `${$t('contas-receber')}: ${titulo.idTituloErp}` }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('financeiro') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('contas-receber') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ this.$route.params.id }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button 
                            class="delete-btn"
                            type="button" 
                            @click="$router.push({ name: 'ven-contas-receber-list' })
                        ">
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <div class="page-container mt-2">
                    <div class="form">
                        <div class="form-titulo">
                            <div class="separator">
                                {{ `${$t('titulo')} - ${titulo.idTituloErp} (${ titulo.diasVencido === 0 ? $t('aberto') : capitalized($t('vencido')) })` }}
                            </div>
                            <div class="data-block">
                                <div
                                    class="info-titulo"
                                    :class="{'w-100': field.label === 'observacao'}"
                                    v-for="(field, index) in fields.filter(({visible}) => visible)"
                                    :key="index"
                                >
                                    <h4 class="label is-align-self-flex-start">
                                        {{ `${$t(field.label)}:` }}
                                    </h4>
                                    <p class="answer" v-if="isNull(titulo[field.key])">
                                        {{ $t('nao-informado') }}
                                    </p>
                                    <p class="answer" v-else-if="field.label === 'cnpjcpf'">
                                        {{ formatCpfCnpj(titulo[field.key]) }}
                                    </p>
                                    <p class="answer" v-else-if="field.label === 'tipo'">
                                        {{ titulo[field.key] === 'C' ? $t('credito') : $t('debito') }}
                                    </p>
                                    <p class="answer" v-else-if="field.label.includes('data')">
                                        {{ $moment(titulo[field.key]).format("L") }}
                                    </p>
                                    <p class="answer" v-else-if="field.label.includes('valor')">
                                        {{ parseAsCurrency(titulo[field.key]) }}
                                    </p>
                                    <p class="answer" v-else-if="field.label === 'indicejuro'">
                                        {{ getDecimal(titulo[field.key]) }}%
                                    </p>
                                    <p class="answer" v-else>
                                        {{ titulo[field.key] }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="titulo.tituloAnotacaoList.length > 0"
                            class="form-titulo"
                        >
                            <div class="separator">
                                {{ $t('anotacoes') }}
                            </div>
                            <div
                                class="data-block"
                                :class="'bottom-border'"
                                v-for="(anotacao, index) in titulo.tituloAnotacaoList"
                                :key="index"
                            >
                                <div
                                    class="info-titulo"
                                    :class="{'w-100': field.label === 'observacao'}"
                                    v-for="(field, index) in anotacaoFields"
                                    :key="index"
                                >
                                    <h4 class="label is-align-self-flex-start">
                                        {{ `${$t(field.label)}:` }}
                                    </h4>
                                    <p class="answer" v-if="isNull(anotacao[field.key])">
                                        {{ $t('nao-informado') }}
                                    </p>
                                    <p class="answer" v-else-if="field.label.includes('data')">
                                        {{ $moment(anotacao[field.key]).format("L LT") }}
                                    </p>
                                    <p class="answer" v-else-if="field.label.includes('valor')">
                                        {{ parseAsCurrency(anotacao[field.key]) }}
                                    </p>
                                    <p class="answer" v-else>
                                        {{ anotacao[field.key] }}
                                    </p>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("ven-contas-receber") && to.name != "ven-contas-receber-list") {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }

        next();
    },
    components: {
        ContainerLoader
    },
    data() {
        return {
            rotaAninhada: false,
            isLoading: false,
            titulo: null,
            fields: [],
            anotacaoFields: [
                { label: 'usuario', key: 'usuario' },
                { label: 'data-hora', key: 'datahora' },
                { label: 'observacao', key: 'anotacao' },
            ], 
        };
    },
    created() {
        this.rotaAninhada = (
            this.$route.name.includes("ven-contas-receber")
            && this.$route.name != "ven-contas-receber-list"
        );

        this.checkForPermission();

        const idTitulo = this.$route.params.id;

        this.getTitulo(idTitulo);
    },
    methods: {
      capitalized(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      mapToView(titulo) {
        return ({
            idTituloErp: titulo.idtituloerp,
            nomeCliente: 
                titulo.cliente ? titulo.cliente.nome : null,
            rSocialCliente: 
                titulo.cliente ? titulo.cliente.rsocial : null,
            cidadeCliente: 
                titulo.cliente &&
                titulo.cliente.cidade ? titulo.cliente.cidade.descricao : null,
            cnpjcpfCliente: titulo.cliente ? titulo.cliente.cnpjcpf : null,
            formaPagto: 
                titulo.formapagto ? titulo.formapagto.descricao : null,
            tipo: titulo.tipo,
            numeroTitulo: titulo.numerotitulo,
            dataEmissao: titulo.dataemissao,
            sequencia: titulo.sequencia,
            dataVencimento: titulo.datavencimento,
            diasVencido: titulo.dias_vencido,
            dataPagamento: titulo.datahorapagamento,
            valorTitulo: titulo.valortitulo,
            valorCorrigido: titulo.valorcorrigido,
            diasVencidos: titulo.dias_vencido,
            indiceJuros: titulo.indicejuro,
            valorJuros: titulo.valor_juros,
            valorComJuros: titulo.valorcorrigido + titulo.valor_juros,
            origemTitulo: 
                titulo.tituloRecebimento && 
                titulo.tituloRecebimento.origem ? titulo.tituloRecebimento.origem : null,
            observacaoTitulo: titulo.obs,
            tituloAnotacaoList: titulo.tituloanotacaoList
        })
      },
      setFields(titulo) {
        this.fields = [
            { label: 'nome', key: 'nomeCliente', visible: true },
            { label: 'rsocial', key: 'rSocialCliente', visible: true },
            { label: 'cnpjcpf', key: 'cnpjcpfCliente', visible: true },
            { label: 'cidade', key: 'cidadeCliente', visible: true },
            { label: 'numero-titulo', key: 'numeroTitulo', visible: true },
            { label: 'forma-pagto', key: 'formaPagto', visible: true },
            { label: 'tipo', key: 'tipo', visible: true },
            { label: 'data-emissao', key: 'dataEmissao', visible: true },
            { label: 'sequencia', key: 'sequencia', visible: true },
            { label: 'data-vencimento', key: 'dataVencimento', visible: true },
            { label: 'dias-vencido', key: 'diasVencido', visible: true },
            { label: 'data-pagamento', key: 'dataPagamento', visible: true },
            { label: 'valor', key: 'valorTitulo', visible: true },
            { label: 'valor-corrigido', key: 'valorCorrigido', visible: true },
            { label: 'indicejuro', key: 'indiceJuros', visible: true },
            { label: 'valor-juros', key: 'valorJuros', visible: titulo.diasVencido },
            { label: 'valor-com-juros', key: 'valorComJuros', visible: titulo.diasVencido },
            { label: 'origem', key: 'origemTitulo', visible: true },
            { label: 'observacao', key: 'observacaoTitulo', visible: true },
        ]
      },
      checkForPermission() {
        const permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "ven-contas-receber"
        );

        if(!permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "contas-receber" },
            });
        }
      },
      getTitulo(idTitulo) {
        this.isLoading = true;

        this.$axios(`/financeiro/contas-receber/full/${idTitulo}.json`)
        .then((response) => {
            const titulo = this.mapToView(response.data.content);
            
            this.titulo = titulo;

            this.setFields(titulo);
        })
        .catch((e) => {
            console.error(e);
            this.$root.showMessage("error", "msg-erro-load");
        })
        .finally((_) => this.isLoading = false);
      }
    }
};
</script>
<style lang="scss" scoped>
.w-100 {
    width: 100% !important;
}

.bottom-border {
    border-bottom: 1px solid rgb(208, 207, 207);
    margin-bottom: 8px;
    padding-bottom: 8px;
}

#main {
    padding: 0 20px;
    height: 100%;

    .header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        height: auto;

        .report-title {
            font-size: 20px;
            margin-bottom: 10px;

            h1 {
                font-weight: 600;
            }
        }
    }

    .form {
        width: 100%;

        .form-titulo {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-bottom: 20px;

            .separator {
                width: 100%;
                border-top: 1px solid $table-border;
                border-bottom: 1px solid $table-border;
                padding: 10px 0;
                text-align: center;
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 18px;
            }

            .data-block {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .info-titulo .label {
                    font-weight: 600;
                    margin: 0 5px 2.5px 0;
                }

                .info-titulo {
                    width: 50%;
                    margin-bottom: 5px;
                    font-size: 14px;

                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
            }
        }

        .form-titulo:last-child {
            margin-bottom: 0px;
        }
    }
}
</style>